<!-- eslint-disable -->

<template>
	<div>
		<div>
			<div v-if="title" class="text-gotham-bold text-18 pb-4">
				{{ title }}
			</div>
			<div
				v-for="(item, index) in data || []"
				:key="item.label + index"
				class="d-flex flex-column pb-2"
			>
				<div class="d-flex justify-content-between">
					<div class="text-gotham align-self-center text-12" :style="item.labelStyle">
						{{ item.label }}
					</div>
					<div class="d-flex"> 
						<div class="align-self-center text-gotham-bold" :style="item.valueStyle" :class="item.key == 'orderNumber'?'text-12':'text-14'">
							{{ item.isDate ? epochToDateTimeLocalFormat(item.value) || "-" : item.value }}
						</div>
						<span :data-cta="cta" @click="buttonSyncCopyClipboard(item.value)" class="text-gotham align-self-center text-12" v-if="item.key == 'orderNumber'"><img src="@/assets/images/ic_copy.svg" ></span>
					</div>
				</div>
				<div v-if="item.info" class="d-flex justify-content-end align-items-center mt-2">
					<span class="text-gotham-bold text-12" style="color:#5F51A1;">{{
						item.info
					}}</span>
					<img src="@/assets/icons/ic_arrowup.svg" alt="arrow_up" />
				</div>
				<hr v-if="item.addBreak" class="w-100" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: String,
		/**
		 * data is an array of object, with object have a field
		 * label: 'test',
		 * value: 'test',
		 * labelStyle: String,
		 * valueStyle: String
		 * isDate: Boolean,
		 * addBreak: Boolean
		 */
		data: Array,
		cta: {
			type: String,
			default: 'infolist_copy_order_number',
		},
	},
};
</script>

<style scoped></style>
